import { IApplicationState } from '../../types/redux';

export const selectHasBlackFridayOffers = (state: IApplicationState): boolean => {
  return state.promosPage.hasBlackFridayOffers;
};
